export default "__VITE_ASSET__536c0c9b__"